import { createClient } from '@supabase/supabase-js'

// Browser client. Uses the anon (public) key. RLS policies do the actual access control.
// ANTHROPIC_API_KEY is never loaded here - it lives in Supabase edge function secrets only.

const url = import.meta.env.VITE_SUPABASE_URL
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!url || !anonKey) {
  // Fail loud in dev, fail loud in build. Missing env is a configuration bug.
  // eslint-disable-next-line no-console
  console.error('Missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY. Copy .env.example to .env.local and fill in.')
}

// ADR-023: no attendee auth session is ever set on this client (the JWT
// mint path was retired). `persistSession` and `autoRefreshToken` were
// both load-bearing under ADR-021 (keep the minted JWT across reloads;
// don't hit the auth endpoint with our fake refresh_token). Both are now
// moot — the client is anon-only — so we drop both flags and let
// supabase-js use its defaults. If a future phase introduces real auth,
// revisit these explicitly.
export const supabase = createClient(url, anonKey, {
  realtime: {
    params: {
      eventsPerSecond: 10,
    },
  },
})
